import { useState } from "react";

import { Stack } from "@braintrust/braintrust-ui-components";
import { EyeIcon } from "@braintrust/braintrust-ui-components/Icons";
import {
  FilterPopover,
  FilterPopoverFooter,
  FilterPopoverFormLayoutWrapper,
} from "@js/apps/employer/components/filter-popover";
import { CheckboxButton } from "@js/components/checkbox-button";
import { useFilterPopover } from "@js/hooks/use-filter-popover";
import { enumToOptions } from "@js/utils";

import type { RosterVisibilityType } from "../../types";

const VISIBILITY_OPTIONS = enumToOptions(ENUMS.RosterVisibilityLabels);

type RostersVisibilityFilterPopoverProps = {
  visibility: RosterVisibilityType | null;
  onChange: (visibility: RosterVisibilityType | null) => void;
};

export const RostersVisibilityFilterPopover = ({
  visibility,
  onChange,
}: RostersVisibilityFilterPopoverProps) => {
  const { isOpen, handleClick, handleClose, anchorElement } =
    useFilterPopover();
  const [draft, setDraft] = useState(visibility);

  const handleToggle = (value: RosterVisibilityType) => {
    setDraft((current) => (current === value ? null : value));
  };

  const handleApply = () => {
    onChange(draft);
    handleClose();
  };

  const label = visibility
    ? ENUMS.RosterVisibilityLabels[visibility]
    : "Visibility";

  return (
    <FilterPopover
      label={label}
      icon={<EyeIcon />}
      isFilterApplied={!!visibility}
      isFilterOpen={isOpen}
      onClick={(event) => {
        setDraft(visibility);
        handleClick(event);
      }}
      onClose={handleClose}
      anchorElement={anchorElement}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleApply();
        }}
      >
        <FilterPopoverFormLayoutWrapper
          formBody={
            <Stack direction="row" sx={{ gap: 1 }}>
              {VISIBILITY_OPTIONS.map(({ value, label: visibilityLabel }) => (
                <CheckboxButton
                  key={value}
                  variant="violet"
                  isSelected={draft === value}
                  label={visibilityLabel}
                  onClick={() => handleToggle(value)}
                />
              ))}
            </Stack>
          }
          formFooter={<FilterPopoverFooter onReset={() => setDraft(null)} />}
        />
      </form>
    </FilterPopover>
  );
};
